import { ApiClient, ApiClientWithAuth } from '@/services/api/client'
import { log } from '@/util/log'
import { Either, left, right } from 'fp-ts/lib/Either'

export class PaidMemberSubscriptionService {
  constructor (
    private readonly apiClient: typeof ApiClient = ApiClientWithAuth
  ) {}

  async getNextPayment(planId: string, subscribeId: string): Promise<Either<Error, NextPayment>> {
    const target = `/api/user/paid_membership/plan/${planId}/${subscribeId}/next_payment`
    try {
      const response = await this.apiClient.get(target)

      log.debug({ service: target, response })

      return right(response.body.data)
    } catch (error) {
      log.error({ service: target, error })

      return left(error)
    }
  }
}

export interface NextPayment {
  plan_id: string
  subscribe_id: string
  next_payment: {
    date: Date
    price: number
  }
  notice: string[]
}
